import moment from 'moment';
import DateUtil from '../utils/DateUtil';
import {TSEigentumsverhaeltnis} from './enums/TSEigentumsverhaeltnis';
import {TSErfassungsArt} from './enums/TSErfassungsArt';
import {TSRechtsform} from './enums/TSRechtsform';
import {TSSchadenfallHerkunft} from './enums/TSSchadenfallHerkunft';
import {TSSchadenfallStatus} from './enums/TSSchadenfallStatus';
import TSAbstractEntity from './TSAbstractEntity';
import TSAdresse from './TSAdresse';
import TSAnlaufstelle from './TSAnlaufstelle';
import TSBeitrag from './TSBeitrag';
import TSBenutzer from './TSBenutzer';
import TSBenutzerBemerkung from './TSBenutzerBemerkung';
import TSEigenleistung from './TSEigenleistung';
import TSEigenleistungStundenDaten from './TSEigenleistungStundenDaten';
import TSFremdkosten from './TSFremdkosten';
import TSGenossenschaft from './TSGenossenschaft';
import TSGesuchsteller from './TSGesuchsteller';
import TSSchaden from './TSSchaden';
import TSSchadenfallDaten from './TSSchadenfallDaten';
import {TSSerializable} from './TSSerializable';
import TSSystemBemerkung from './TSSystemBemerkung';
import TSTransitionBemerkung from './TSTransitionBemerkung';
import TSVorleistung from './TSVorleistung';

export default class TSSchadenfall extends TSAbstractEntity implements TSSerializable<TSSchadenfall> {
    public static readonly FALLNUMMER_LENGTH: number = 8;

    private _schadenfallHerkunft: TSSchadenfallHerkunft | undefined;

    private _erfassungsart: TSErfassungsArt;

    private _anlaufstelle: TSAnlaufstelle | undefined;

    private _besitzer: TSBenutzer | undefined;

    private _gesuchsteller: TSGesuchsteller;

    private _zweitperson: TSGesuchsteller | undefined;

    private _gesuchsdatum: moment.Moment | undefined;

    private _bemerkung: string;

    private _fallNummer: number;

    private _status: TSSchadenfallStatus;

    private _schadenfallDatenFS: TSSchadenfallDaten | undefined;

    private _schadenfallDatenGS: TSSchadenfallDaten | undefined;

    private _schaeden: Array<TSSchaden>;

    private _schaetzer: Array<TSBenutzer>;

    private _fremdkosten: Array<TSFremdkosten>;

    private _vorleistungen: Array<TSVorleistung>;

    private _eigenleistungen: Array<TSEigenleistung>;

    private _beitraege: Array<TSBeitrag>;

    private _ermittelterSchaden: number = 0;

    private _nichtBerechtigterAnteil: number = 0;

    private _berechtigterBetragEigenleistungen: number = 0;
    private _berechtigterBetragFremdkosten: number = 0;
    private _berechtigterBetragVorleistungen: number = 0;

    private _systemBemerkungen: Array<TSSystemBemerkung>;

    private _benutzerBemerkungen: Array<TSBenutzerBemerkung>;

    private _transitionBemerkungen: Array<TSTransitionBemerkung>;

    public get schadenfallHerkunft(): TSSchadenfallHerkunft | undefined {
        return this._schadenfallHerkunft;
    }

    public set schadenfallHerkunft(value: TSSchadenfallHerkunft | undefined) {
        this._schadenfallHerkunft = value;
    }

    public get erfassungsart(): TSErfassungsArt {
        return this._erfassungsart;
    }

    public set erfassungsart(value: TSErfassungsArt) {
        this._erfassungsart = value;
    }

    public get gesuchsdatum(): moment.Moment | undefined {
        return this._gesuchsdatum;
    }

    public set gesuchsdatum(value: moment.Moment | undefined) {
        this._gesuchsdatum = value;
    }

    public get bemerkung(): string {
        return this._bemerkung;
    }

    public set bemerkung(value: string) {
        this._bemerkung = value;
    }

    public get fallNummer(): number {
        return this._fallNummer;
    }

    public set fallNummer(value: number) {
        this._fallNummer = value;
    }

    public get status(): TSSchadenfallStatus {
        return this._status;
    }

    public set status(value: TSSchadenfallStatus) {
        this._status = value;
    }

    public get anlaufstelle(): TSAnlaufstelle | undefined {
        return this._anlaufstelle;
    }

    public set anlaufstelle(value: TSAnlaufstelle | undefined) {
        this._anlaufstelle = value;
    }

    public get besitzer(): TSBenutzer | undefined {
        return this._besitzer;
    }

    public set besitzer(value: TSBenutzer | undefined) {
        this._besitzer = value;
    }

    public get schadenfallDatenFS(): TSSchadenfallDaten | undefined {
        return this._schadenfallDatenFS;
    }

    public set schadenfallDatenFS(value: TSSchadenfallDaten | undefined) {
        this._schadenfallDatenFS = value;
    }

    public get schadenfallDatenGS(): TSSchadenfallDaten | undefined {
        return this._schadenfallDatenGS;
    }

    public set schadenfallDatenGS(value: TSSchadenfallDaten | undefined) {
        this._schadenfallDatenGS = value;
    }

    public get schaeden(): Array<TSSchaden> {
        return this._schaeden;
    }

    public set schaeden(value: Array<TSSchaden>) {
        this._schaeden = value;
    }

    public get schaetzer(): Array<TSBenutzer> {
        return this._schaetzer;
    }

    public set schaetzer(value: Array<TSBenutzer>) {
        this._schaetzer = value;
    }

    public get gesuchsteller(): TSGesuchsteller {
        return this._gesuchsteller;
    }

    public set gesuchsteller(value: TSGesuchsteller) {
        this._gesuchsteller = value;
    }

    public get zweitperson(): TSGesuchsteller | undefined {
        return this._zweitperson;
    }

    public set zweitperson(value: TSGesuchsteller | undefined) {
        this._zweitperson = value;
    }

    public get fremdkosten(): Array<TSFremdkosten> {
        return this._fremdkosten;
    }

    public getFinalFremdkosten(): Array<TSFremdkosten> {
        return this._fremdkosten.filter(e => !e.schaetzung);
    }

    public getSchaetzungFremdkosten(): Array<TSFremdkosten> {
        return this._fremdkosten.filter(e => e.schaetzung);
    }

    public set fremdkosten(value: Array<TSFremdkosten>) {
        this._fremdkosten = value;
    }

    public get vorleistungen(): Array<TSVorleistung> {
        return this._vorleistungen;
    }

    public getFinalVorleistungen(): Array<TSVorleistung> {
        return this.vorleistungen.filter(e => !e.schaetzung);
    }

    public getSchaetzungVorleistungen(): Array<TSVorleistung> {
        return this.vorleistungen.filter(e => e.schaetzung);
    }

    public set vorleistungen(value: Array<TSVorleistung>) {
        this._vorleistungen = value;
    }

    public get eigenleistungen(): Array<TSEigenleistung> {
        return this._eigenleistungen;
    }

    public getFinalEigenleistungen(): Array<TSEigenleistung> {
        return this._eigenleistungen.filter(e => !e.schaetzung);
    }

    public getSchaetzungEigenleistungen(): Array<TSEigenleistung> {
        return this._eigenleistungen.filter(e => e.schaetzung);
    }

    public set eigenleistungen(value: Array<TSEigenleistung>) {
        this._eigenleistungen = value;
    }

    public get beitraege(): Array<TSBeitrag> {
        return this._beitraege;
    }

    public set beitraege(value: Array<TSBeitrag>) {
        this._beitraege = value;
    }

    public get ermittelterSchaden(): number {
        return this._ermittelterSchaden;
    }

    public set ermittelterSchaden(value: number) {
        this._ermittelterSchaden = value;
    }

    public get nichtBerechtigterAnteil(): number {
        return this._nichtBerechtigterAnteil;
    }

    public set nichtBerechtigterAnteil(value: number) {
        this._nichtBerechtigterAnteil = value;
    }

    public get berechtigterBetragEigenleistungen(): number {
        return this._berechtigterBetragEigenleistungen;
    }

    public set berechtigterBetragEigenleistungen(value: number) {
        this._berechtigterBetragEigenleistungen = value;
    }

    public get berechtigterBetragFremdkosten(): number {
        return this._berechtigterBetragFremdkosten;
    }

    public set berechtigterBetragFremdkosten(value: number) {
        this._berechtigterBetragFremdkosten = value;
    }

    public get berechtigterBetragVorleistungen(): number {
        return this._berechtigterBetragVorleistungen;
    }

    public set berechtigterBetragVorleistungen(value: number) {
        this._berechtigterBetragVorleistungen = value;
    }

    public get systemBemerkungen(): Array<TSSystemBemerkung> {
        return this._systemBemerkungen;
    }

    public set systemBemerkungen(value: Array<TSSystemBemerkung>) {
        this._systemBemerkungen = value;
    }

    public get benutzerBemerkungen(): Array<TSBenutzerBemerkung> {
        return this._benutzerBemerkungen;
    }

    public set benutzerBemerkungen(value: Array<TSBenutzerBemerkung>) {
        this._benutzerBemerkungen = value;
    }

    public get transitionBemerkungen(): Array<TSTransitionBemerkung> {
        return this._transitionBemerkungen;
    }

    public set transitionBemerkungen(value: Array<TSTransitionBemerkung>) {
        this._transitionBemerkungen = value;
    }

    public init(): TSSchadenfall {
        this.gesuchsteller = new TSGesuchsteller();
        return this;
    }

    public getFallnummerWithZeros(): string {
        return TSSchadenfall.calculateFallnummerWithZeros(this._fallNummer);
    }

    deserialize(restObject: any): TSSchadenfall {
        super.deserialize(restObject);
        this.gesuchsdatum = DateUtil.localDateToMoment(restObject.gesuchsdatum);
        this.schadenfallHerkunft = restObject.schadenfallHerkunft;
        this.bemerkung = restObject.bemerkung;
        this.fallNummer = restObject.fallNummer;
        this.status = restObject.status;
        this.erfassungsart = restObject.erfassungsArt;
        this.anlaufstelle = this.deserializeOrNull(restObject.anlaufstelle, new TSAnlaufstelle());
        this.schadenfallDatenFS = this.deserializeOrNull(restObject.schadenfallDatenFS, new TSSchadenfallDaten());
        this.schadenfallDatenGS = this.deserializeOrNull(restObject.schadenfallDatenGS, new TSSchadenfallDaten());
        this.besitzer = this.deserializeOrNull(restObject.besitzer, new TSBenutzer());
        this.ermittelterSchaden = restObject.ermittelterSchaden;
        this.nichtBerechtigterAnteil = restObject.nichtBerechtigterAnteil;
        this.berechtigterBetragEigenleistungen = restObject.berechtigterBetragEigenleistungen;
        this.berechtigterBetragFremdkosten = restObject.berechtigterBetragFremdkosten;
        this.berechtigterBetragVorleistungen = restObject.berechtigterBetragVorleistungen;

        if (restObject.schaeden) {
            this.schaeden = restObject.schaeden.map(TSSchaden.getDeserializer);
        }
        if (restObject.fremdkosten) {
            this.fremdkosten = restObject.fremdkosten.map(TSFremdkosten.getDeserializer);
        }
        if (restObject.vorleistungen) {
            this.vorleistungen = restObject.vorleistungen.map(TSVorleistung.getDeserializer);
        }
        if (restObject.eigenleistungen) {
            this.eigenleistungen = restObject.eigenleistungen.map(TSEigenleistung.getDeserializer);
        }

        if (restObject.beitraege) {
            this.beitraege = restObject.beitraege.map(TSBeitrag.getDeserializer);
        }
        if (restObject.systemBemerkungen) {
            this.systemBemerkungen = restObject.systemBemerkungen.map(TSSystemBemerkung.getDeserializer);
        }
        if (restObject.benutzerBemerkungen) {
            this.benutzerBemerkungen = restObject.benutzerBemerkungen.map(TSBenutzerBemerkung.getDeserializer);
        }
        if (restObject.transitionBemerkungen) {
            this.transitionBemerkungen = restObject.transitionBemerkungen.map(TSTransitionBemerkung.getDeserializer);
        }

        if (restObject.schaetzer) {
            this.schaetzer = restObject.schaetzer.map(TSBenutzer.getDeserializer);
        }

        this.gesuchsteller = this.deserializeOrCreate(restObject.gesuchsteller, new TSGesuchsteller());

        if (restObject.zweitperson) {
            this.zweitperson = this.deserializeOrCreate(restObject.zweitperson, new TSGesuchsteller());
            this.zweitperson.isZweitperson = true; // beim serialisieren der Zweitperson flag setzen (wird für cleanup gebraucht!)
        }

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.bemerkung = this.bemerkung;
        restObject.schadenfallHerkunft = this.schadenfallHerkunft;
        restObject.anlaufstelle = this.serializeOrInit(this.anlaufstelle, restObject.anlaufstelle);
        restObject.schadenfallDatenFS = this.serializeOrInit(this.schadenfallDatenFS, restObject.schadenfallDatenFS);
        restObject.schadenfallDatenGS = this.serializeOrInit(this.schadenfallDatenGS, restObject.schadenfallDatenGS);
        restObject.gesuchsteller = this.serializeOrInit(this.gesuchsteller, restObject.gesuchsteller);
        restObject.zweitperson = this.serializeOrInit(this.zweitperson, restObject.zweitperson);
        restObject.schaetzer = this.arrayToRestObject(this.schaetzer);
        restObject.ermittelterSchaden = this.ermittelterSchaden;
        restObject.nichtBerechtigterAnteil = this.nichtBerechtigterAnteil;
        restObject.berechtigterBetragEigenleistungen = this.berechtigterBetragEigenleistungen;
        restObject.berechtigterBetragFremdkosten = this.berechtigterBetragFremdkosten;
        restObject.berechtigterBetragVorleistungen = this.berechtigterBetragVorleistungen;
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        // don't send schaeden, fremdkosten, vorleistungen, eigenleistungen
        // and bemerkungen to server because this is not the way to persist them!
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

        return restObject;
    }

    public static calculateFallnummerWithZeros(fallnummer: number): string {
        let fallnummerString = '' + fallnummer;
        while (fallnummerString.length < TSSchadenfall.FALLNUMMER_LENGTH) {
            fallnummerString = '0' + fallnummerString;
        }
        return fallnummerString;
    }

    public getErmittelterSchaden(): number {
        return this.ermittelterSchaden;
    }

    /**
     * /!\
     * Die Summen werden im Backend und Frontend getrennt kalkuliert.
     * Falls nötig, müssen sie immer an beiden Stellen synchron geändert werden.
     * Siehe auch FinanzCalculatorUtil.java
     */

    public getCalculatedNichtBerechtigterAnteil(): number {
        return (this.ermittelterSchaden * (this.nichtBerechtigterAnteil / 100));
    }

    public hasEigenleistungen(): boolean {
        if (this.eigenleistungen !== undefined && this.eigenleistungen !== null) {
            return this.getFinalEigenleistungen().length > 0;
        }
        return false;
    }

    public hasFremdkosten() {
        if (this.fremdkosten !== undefined && this.fremdkosten !== null) {
            return this.getFinalFremdkosten().length > 0;
        }
        return false;
    }

    public hasVorleistungen() {
        if (this.vorleistungen !== undefined && this.vorleistungen !== null) {
            return this.getFinalVorleistungen().length > 0;
        }
        return false;
    }

    public hasBeitrag(): boolean {
        if (this.beitraege !== undefined && this.beitraege !== null) {
            return this.beitraege.length > 0;
        }
        return false;
    }

    public getAbrechnungsbetrag(schaetzung: boolean): number {
        let val: number = 0;

        val += this.getEigenleistungenTotal(schaetzung);
        val += this.getFremdkostenTotal(schaetzung);
        val -= this.getVorleistungenTotal(schaetzung);

        if (schaetzung && val === 0) {
            if (this.schaeden[0] !== undefined && this.schaeden[0].schadenDatenFS !== undefined &&
                this.schaeden[0].schadenDatenFS.geschaetzteKosten !== undefined) {
                // @ts-ignore
                val += this.schaeden[0].schadenDatenFS.geschaetzteKosten;
            }
        }

        return val;
    }

    public getAnrechenbarerSchaden(prozentsatz: number = 100): number {
        let schadendatum: moment.Moment | undefined = undefined;

        if (this.schaeden !== undefined && this.schaeden.length > 0 && this.schaeden[0].schadenDatenFS !== undefined) {
            schadendatum = this.schaeden[0].schadenDatenFS.schadendatum;
        }
        const abzuege = this.gesuchsteller.getEinkommensabzug()
            + this.gesuchsteller.getVermoegenssabzug(schadendatum, this.ermittelterSchaden)
            + this.getCalculatedNichtBerechtigterAnteil();
        return (this.ermittelterSchaden - abzuege) * (prozentsatz / 100);

    }

    public getEigenleistungenTotal(schaetzung: boolean): number {
        return schaetzung ? this.getSchaetzungEigenleistungenTotal() : this.getFinalEigenleistungenTotal();
    }

    public getFinalEigenleistungenTotal(): number {
        return this.berechtigterBetragEigenleistungen !== undefined ? this.berechtigterBetragEigenleistungen : 0;
    }

    public getSchaetzungEigenleistungenTotal(): number {
        let val: number = 0;
        this.getSchaetzungEigenleistungen().forEach((eigenleistung) => {
            val += eigenleistung.eigenleistungStundenDaten.reduce(
                (accumulator: number, currentValue: TSEigenleistungStundenDaten) => accumulator + currentValue.betrag, 0);
            if (eigenleistung.eigenleistungKubikmeterDaten !== undefined) {
                val += eigenleistung.eigenleistungKubikmeterDaten.betrag;
            }
            if (eigenleistung.eigenleistungLiterDaten !== undefined) {
                val += eigenleistung.eigenleistungLiterDaten.betrag;
            }
        });
        return val;
    }

    public getFremdkostenTotal(schaetzung: boolean): number {
        return schaetzung ? this.getSchaetzungFremdkostenTotal() : this.getFinalFremdkostenTotal();
    }

    public getFinalFremdkostenTotal(): number {
        return this.berechtigterBetragFremdkosten;
    }

    public getSchaetzungFremdkostenTotal(): number {
        let val: number = 0;
        this.getSchaetzungFremdkosten().forEach((fremdkosten) => {
            val += fremdkosten.fremdkostenDatenFS.rechnungsbetrag;
        });
        return val;
    }

    public getVorleistungenTotal(schaetzung: boolean): number {
        return schaetzung ? this.getSchaetzungVorleistungenTotal() : this.getFinalVorleistungenTotal();
    }

    public getFinalVorleistungenTotal(): number {
        return this.berechtigterBetragVorleistungen;
    }

    public getSchaetzungVorleistungenTotal(): number {
        let val: number = 0;
        this.getSchaetzungVorleistungen().forEach((vorleistung) => {
            val += vorleistung.vorleistungDatenFS.betrag;
        });
        return val;
    }

    public cleanupGesuchsteller(): void {
        this.gesuchsteller.cleanup();
        if (this.gesuchsteller.eigentumsverhaeltnis === TSEigentumsverhaeltnis.GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER) {
            this.zweitperson = undefined;
        } else {
            if (this.zweitperson !== undefined) {
                this.zweitperson.cleanup();
            }
        }
    }

    public setEmptyStringsIfNotSet() {
        let person: TSGesuchsteller = this.gesuchsteller;
        this.check(person);
        let zweitperson: TSGesuchsteller | undefined = this.zweitperson;
        if (zweitperson) {
            this.check(zweitperson);
        }
    }

    private check(person: TSGesuchsteller) {
        if (person.rechtsform === TSRechtsform.GENOSSENSCHAFT) {
            let genossenschaftAdresse = person.genossenschaft!.genossenschaftDatenFS.adresse;
            if (person.genossenschaft) {
                this.checkGenossenName(person.genossenschaft);
            }
            this.handleAddress(genossenschaftAdresse);
        }
        if (person.kontaktperson) {
            let kontaktaAdresse = person.kontaktperson!.gesuchsPersonDatenFS.adresse;
            this.handleAddress(kontaktaAdresse);
        }
    }

    private handleAddress(adresse: TSAdresse | undefined) {
        if (!adresse) {
            adresse = new TSAdresse();
        }
        this.initFieldIfNecessary(adresse, 'strasse');
        this.initFieldIfNecessary(adresse, 'ort');
        this.initFieldIfNecessary(adresse, 'plz');
    }

    private initFieldIfNecessary(address: TSAdresse, field: keyof TSAdresse) {
        if (!address[field]) {
            address[field] = '';
        }

    }

    private checkGenossenName(genossen: TSGenossenschaft) {
        if (!genossen.genossenschaftDatenFS.name) {
            genossen.genossenschaftDatenFS.name = '';
        }
    }

    public getRelevanteEigenleistungen(schaetzung: boolean) {
        return schaetzung ? this.getSchaetzungEigenleistungen() : this.getFinalEigenleistungen();
    }

    public getRelevanteFremdkosten(schaetzung: boolean) {
        return schaetzung ? this.getSchaetzungFremdkosten() : this.getFinalFremdkosten();
    }

    public getRelevanteVorleistungen(schaetzung: boolean) {
        return schaetzung ? this.getSchaetzungVorleistungen() : this.getFinalVorleistungen();
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSSchadenfall.ts